import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

import { globalTypes } from '@/shared/duck';

interface Props {
  initialFiles: globalTypes.InitialDropzoneFile[];
  disabled: boolean;
  onDeleteInitialFile?: (fileId: string) => void;
  onDownloadInitialFile?: (filePath: string) => void;
}

const InitialFilesBlock: React.FC<Props> = ({
  initialFiles,
  onDownloadInitialFile,
  onDeleteInitialFile,
  disabled,
}) => {
  const handleRemoveInitialFile = (fileId: string) => {
    if (!onDeleteInitialFile) {
      return;
    }
      onDeleteInitialFile(fileId);
  };

  const handleDownloadInitialFile = (filePath: string) => {
    if (!onDownloadInitialFile) {
      return;
    }
      onDownloadInitialFile(filePath);
    };

  return (
    <>
      {initialFiles.map((file) => (
        <Paper
          key={file.id}
          elevation={3}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '1rem',
            borderRadius: '8px',
          }}
        >
          <Box display='flex' alignItems='center' gap={2} width='100%'>
            <InsertDriveFileIcon color='info' />
            <Box width='100%'>
              <Typography
                variant='body2'
                width='fit-content'
                noWrap
                title={file.filePath}
              >
                {file.name}
              </Typography>
              {file.size !== undefined && (
                <Typography variant='caption' color='textSecondary'>
                  {(
                    file.size / 1048576
                  ).toFixed(2)} MB
                </Typography>
              )}
            </Box>
          </Box>
          <Stack direction='row' spacing={1}>
            {onDownloadInitialFile && (
              <IconButton
                onClick={() => handleDownloadInitialFile(file.filePath)}
                color='primary'
                disabled={disabled}
                title='Download file'
              >
                <FileDownloadOutlinedIcon />
              </IconButton>
            )}
            {onDeleteInitialFile && (
              <IconButton
                onClick={() => handleRemoveInitialFile(file.id)}
                color='error'
                disabled={disabled}
                title='Delete file'
              >
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            )}
          </Stack>
        </Paper>
      ))}
    </>
  );
};

export default InitialFilesBlock;